import { MessageSquare } from "lucide-react";

const ItemsList = ({ order }) => {
  const totalQty = order.orderItems.reduce((sum, i) => sum + i.qty, 0);
  console.log({ order });

  return (
    <div className="bg-white rounded-xl shadow">
      {/* ✅ STATUS HEADER */}
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <div className="flex items-center gap-2">
          {/* green badge */}
          <span className="bg-green-100 text-green-700 text-xs px-3 py-1 rounded-full font-medium">
            Picked up (${totalQty})
          </span>

          {/* order code */}
          <span className="text-sm text-gray-700 font-medium">
            #{order._id.slice(-4)}-F1
          </span>
        </div>

        <span className="text-gray-400 text-sm">•••</span>
      </div>

      {/* optional sub info */}
      <div className="px-4 py-2 text-xs text-gray-500 border-b">
        {new Date(order.createdAt).toLocaleString()} • {order.operator?.name}
      </div>

      {/* CUSTOMER NOTE */}

      {/* ITEMS */}
      <div className="p-4">
        <div className="flex justify-between mb-3">
          <h2 className="font-semibold">Items</h2>
          <span className="text-xs text-gray-400">
            {order.orderItems.length} items
          </span>
        </div>

        {order.orderItems.map((item) => (
          <div
            key={item._id}
            className="flex items-start gap-3 py-3 border-b last:border-none"
          >
            {/* Image */}
            <img
              src={item.foodItem?.image}
              className="w-12 h-12 rounded-lg object-cover border"
              alt=""
            />

            {/* Info */}
            <div className="flex-1 min-w-0">
              {/* Title */}
              <p className="font-medium text-gray-800 truncate">{item.title}</p>

              {/* Option */}
              {item.selectedOption && (
                <div className="mt-1">
                  <span className="text-xs text-gray-400 mr-2">Option:</span>
                  <span className="inline-flex items-center text-sm font-semibold bg-amber-100 text-amber-800 px-3 py-1 rounded-md">
                    {item.selectedOption}
                  </span>
                </div>
              )}

              {/* Price */}
              <p className="text-xs text-gray-500 mt-1">
                ${item.price.toFixed(2)}
              </p>
            </div>

            {/* Qty */}
            <div className="text-sm font-medium text-gray-700">
              × {item.qty}
            </div>
          </div>
        ))}
      </div>

      {order.customer_info?.message && (
        <div className="px-4 py-3 border-y bg-amber-50/60">
          <div className="flex items-start gap-3">
            {/* Icon */}
            <div className="mt-0.5">
              <MessageSquare size={16} className="text-amber-500" />
            </div>

            {/* Content */}
            <div className="flex-1">
              <p className="text-xs font-semibold text-amber-700 uppercase tracking-wide">
                Customer note
              </p>
              <p className="text-sm text-gray-700 mt-0.5 leading-relaxed">
                {order.customer_info.message}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemsList;
